import styled from 'styled-components';
import {
  lineHeight,
  fontFamily,
  fontSize,
  fontWeight,
  space,
  color,
} from 'styled-system';

export default styled.span`
  ${lineHeight}
  ${fontFamily}
  ${fontSize}
  ${fontWeight}
  ${space}
  ${color}
`;
